// report_data shape (FieldNoteReport, synced as text):
// { sections: [{ heading, type: "string"|"list"|..., content }], table_data?: [...] }
export interface Section { heading: string; type: string; content: unknown }
export interface ReportData { sections: Section[]; table_data?: unknown[]; [k: string]: unknown }

export function parseReport(raw?: string | null): ReportData | null {
  if (!raw) return null;
  try {
    let v = JSON.parse(raw);
    if (typeof v === "string") v = JSON.parse(v);
    if (!v || !Array.isArray(v.sections)) return null;
    return v as ReportData;
  } catch {
    return null;
  }
}

// Editable text form of any section content.
export function toText(content: unknown): string {
  if (content == null) return "";
  if (typeof content === "string") return content;
  if (Array.isArray(content)) return content.map((c) => (typeof c === "string" ? c : typeof c === "object" && c ? Object.values(c).join(" — ") : String(c))).join("\n");
  if (typeof content === "object") return Object.entries(content as Record<string, unknown>).map(([k, v]) => `${k}: ${typeof v === "object" ? JSON.stringify(v) : v}`).join("\n");
  return String(content);
}

export function fromText(original: unknown, text: string): unknown {
  if (Array.isArray(original) && original.every((x) => typeof x === "string")) return text.split("\n").map((s) => s.trim()).filter(Boolean);
  if (typeof original === "string" || original == null) return text;
  return text; // structured content edits fall back to text; the server keeps the original in versions
}
